export type CardType =
    | 'american-express'
    | 'diners-club'
    | 'visa'
    | 'jcb'
    | 'unionpay'
    | 'discover'
    | 'mastercard'
    | 'maestro'
    | 'delta'

const typeMap: Array<{ validator: CardType; vault: string; gps: string }> = [
    {
        validator: 'visa',
        vault: 'Visa',
        gps: 'VISA'
    },
    {
        validator: 'american-express',
        vault: 'AmericanExpress',
        gps: 'AMERICAN_EXPRESS'
    },
    {
        validator: 'diners-club',
        vault: 'Diners',
        gps: 'DINERS'
    },
    {
        validator: 'discover',
        vault: 'Discover',
        gps: 'DISCOVER'
    },
    {
        validator: 'jcb',
        vault: 'JCB',
        gps: 'JCB'
    },
    {
        validator: 'unionpay',
        vault: 'UnionPay',
        gps: 'UNION_PAY'
    },
    {
        validator: 'maestro',
        vault: 'Maestro',
        gps: 'MAESTRO'
    },
    {
        validator: 'mastercard',
        vault: 'Mastercard',
        gps: 'MASTERCARD'
    },
    {
        validator: 'delta',
        vault: 'Delta',
        gps: 'DELTA'
    }
]

export const cardTypes = typeMap.map(({ validator }) => validator)

export function isCardType(value?: string): value is CardType {
    return value !== undefined && (cardTypes as Array<string>).includes(value)
}

export const getCardType: (input: string) => CardType | undefined = (input: string) => {
    const type = typeMap.find(({ validator, vault, gps }) => {
        return input == validator || input == vault || input == gps
    })
    return type ? type.validator : undefined
}
